import styled from 'styled-components';

export const OTPInputStyled = styled.div`
  .otpContainer{
    display: flex;
    gap: 15px;

    .inputField {
        height: 52px;
        font-size: 17px;
        border-radius: 8px;
        text-align: center;
    }
  }
`;
